// extracted by mini-css-extract-plugin
module.exports = {"dopinfoMod":"comments-bottom_dopinfoMod__Hyeov","dopinfoWrapper":"comments-bottom_dopinfoWrapper__1sOEe"};